import { Box, TableCell, TableRow } from '@mui/material';
import classNames from 'classnames';
import { getMuiOrderDirection } from '../../../../Hooks/useListOrder';
import TableHeaderVerticalDivider from '../TableHeaderVerticalDivider';
import { Column } from '../VirtualizedTable.types';
import { useStyles } from '../virtualizedTable.styles';

export interface FakeHeaderProps<T> {
  columns: Column<T>[];
  hasRowCheckbox: boolean;
  isUsingSelectAll: boolean;
  hasExtraHeader: boolean;
  hasActionsColumn: boolean;
}

const FakeHeader = <T,>({
  columns,
  hasRowCheckbox,
  isUsingSelectAll,
  hasExtraHeader,
  hasActionsColumn,
}: FakeHeaderProps<T>) => {
  const { classes } = useStyles();

  return (
    <TableRow style={{ visibility: 'collapse' }}>
      {isUsingSelectAll && !!hasRowCheckbox && (
        <TableCell
          padding="none"
          className={classNames({
            [classes.checkbox]: true,
            [classes.headerCell]: true,
            [classes.withExtraHeader]: hasExtraHeader,
          })}
        >
          <></>
        </TableCell>
      )}
      {columns.map((column, index) => {
        const isFirstColumn = index === 0;
        if (column.sortable) {
          return (
            <TableCell
              key={column.name}
              sortDirection={getMuiOrderDirection('asc') || false}
              className={classNames({
                [classes.headerCell]: true,
                [classes.withExtraHeader]: hasExtraHeader,
                [classes.fixedCell]: column.fixedHorizontalScroll,
              })}
              style={{
                width: column.width,
                minWidth: column.width,
                maxWidth: column.width,
              }}
            >
              <Box
                sx={{
                  width: column.width ?? 'auto',
                  minWidth: column.width ?? 'auto',
                  maxWidth: column.width ?? 'auto',
                  columnGap: '8px',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                {!isFirstColumn && <TableHeaderVerticalDivider />}
              </Box>
            </TableCell>
          );
        }

        return (
          <TableCell
            key={column.name}
            className={classNames({
              [classes.headerCell]: true,
              [classes.withExtraHeader]: hasExtraHeader,
              [classes.fixedRightCell]: column.fixedRight,
            })}
            sx={{
              width: column.width,
              minWidth: column.width,
              maxWidth: column.width,
            }}
          >
            <Box
              sx={{
                width: column.width ?? 'auto',
                minWidth: column.width ?? 'auto',
                maxWidth: column.width ?? 'auto',
                columnGap: '8px',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {!isFirstColumn && <TableHeaderVerticalDivider />}
            </Box>
          </TableCell>
        );
      })}
      {hasActionsColumn && (
        <TableCell
          padding="checkbox"
          className={classNames({
            [classes.actionsColumn]: true,
            [classes.withExtraHeader]: hasExtraHeader,
          })}
          align="center"
        >
          <></>
        </TableCell>
      )}
    </TableRow>
  );
};

export default FakeHeader;
